import React, { useEffect, useState, Fragment } from "react";
import { Image } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddButton from "./AddButton";
import { get_suggested_items } from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";

const CarouselMain = (props) => {
  const onSuccess = (data) => {
    //setSuggestions(data);
  };
  useEffect(() => {
    for (let i = 0; i < props.vendor_suggestions_menu.length; i++) {
      props.vendor_suggestions_menu[i].cartLength = 0;
    }
    setSuggestions(props.vendor_suggestions_menu);
  }, [props.vendor_suggestions_menu]);

  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    let uniqueCategory = [];
    for (let i = 0; i < props.cart_data.length; i++) {
      if (!uniqueCategory.includes(props.cart_data[i][0].category)) {
        uniqueCategory.push(props.cart_data[i][0].category);
      }
    }

    if (uniqueCategory.length !== 0) {
      const token = props.auth.user.accessToken;
      const formData = {};

      formData.cross_selling_category = uniqueCategory;

      props.get_suggested_items(token, formData, onSuccess);
    }
  }, [props.cart_data]);
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      partialVisibilityGutter: 40,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 40,
    },
  };
  return (
    <Carousel
      showDots
      partialVisible={true}
      responsive={responsive}
      removeArrowOnDeviceType={[
        "tablet",
        "mobile",
        "desktop",
        "superLargeDesktop",
      ]}
    >
      {/* <div
          id="carouselExampleControls"
          class="carousel slide"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            {suggestions.map((data, index) => {
              return (
                <li
                  data-target="#carouselExampleControls"
                  data-slide-to={`${index}`}
                  class={`${index === 0 && `active`}`}
                  key={index}
                ></li>
              );
            })}
          </ol> */}
      {/* <div class="carousel-inner f12-400"> */}
      {suggestions.map((data, index) => {
        return (
          // <div class={`carousel-item ${data.id === 0 && `active`}`}>
          <div class="card" style={{ margin: "5px 5px 25px" }} key={index}>
            <img
              class="card-img-top border-bottom"
              //src={require("../../../../assets/images/Orders/Mask Group 113.png")}
              src={(data && data.images && data.images[0]) || NOTAVAILABLEIMAGE}
              alt={data && data?.name}
              title={data && data?.name}
              style={{
                maxWidth: "100%",
                height: "25vh",
                // height:'auto'
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "5%",
              }}
              class="bottom-left"
              className="badge badge-warning"
            >
              {data && data?.primary_tag && data?.primary_tag[0]?.title}
            </div>
            <div class="card-body">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      {ITEMTYPEVEG.map((type, index) => {
                        return (
                          <React.Fragment key={index}>
                            {data?.itemType === type?.value ? (
                              <Image
                                width="15px"
                                height="15px"
                                src={type.url}
                                alt={type.title}
                                title={type.title}
                                fluid
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      })}{" "}
                    </td>
                    <td>
                      <span className="f12-700">{data.name}</span>
                      <br />
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/star.svg")}
                        width="10px"
                        heigth="10px"
                      />
                      {data?.rating !== undefined && data?.rating !== null
                        ? data?.rating
                        : 0.0}{" "}
                      (
                      {data?.reviews !== undefined && data?.reviews !== null
                        ? data?.reviews
                        : 0}{" "}
                      reviews)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                        width="30px"
                      />
                    </td>
                    <td>
                      <span className="f12-700">
                        {" "}
                        {data?.[props.orderData.orderSelected]?.sizes?.map(
                          (item, index) => (
                            <Fragment key={index}>
                              {item.isDefault ? item.price : <> </>}
                            </Fragment>
                          )
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <button
                type="button"
                class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                title="Save Button"
              >
                Add
              </button> */}
              <AddButton
                customizationData={data}
                orderSelected={props.orderData.orderSelected}
                categoryName={data.name}
              />
            </div>
          </div>
          // </div>
        );
      })}
      {/* </div> */}
      {/* <a
                      class="carousel-control-prev"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="prev"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a
                      class="carousel-control-next"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="next"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Next</span>
                    </a> */}
      {/* </div> */}
      {/* <div>Item 2</div>
        <div>Item 3</div>
        <div>Item 4</div> */}
    </Carousel>
  );
};

// const suggestions = [
//   {
//     id: 0,
//     title: "Pepsi (250ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
//   {
//     id: 1,
//     title: "7up (500ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
//   {
//     id: 2,
//     title: "Pepsi (250ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
// ];

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_cart_data,
  orderData: state.vendorOrdering.vendor_order_data,
  order_id: state.vendorOrdering.order_id,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu,
  vendor_suggestions_menu: state.vendorOrdering.vendor_suggestions_menu,
});

// const mapDispathToProps = (dispatch) => ({
//   addTips: (tipamt) => {
//     dispatch({ type: SET_ORDER_TIP, id: tipamt });
//   },
//   // updateProduct: (id) => {
//   //   dispatch({ type: "UPDATE_PRODUCT", id: id });
//   // },
// });

export default withRouter(
  connect(mapStateToProps, { get_suggested_items })(CarouselMain)
);
